// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__wSXEj","title":"styles_title__2WjkJ","funeralDetails":"styles_funeralDetails__r5_Vw"};